/**
 * Visningsformatering af beløb (dansk format, komma-decimaler).
 * KUN formatering — al beregning sker i src/domain.
 */

import { formatKr, formatKrAmount } from "@/lib/formatKr";

/** "1.234,56 kr" (evt. med "/stk."-suffiks) — kanonisk format via formatKr. */
export function formatPrice(amount: number, opts?: { perUnit?: boolean }): string {
  return `${formatKr(amount)}${opts?.perUnit ? "/stk." : ""}`;
}

/** Kort beløb uden valuta: "1.234,56". */
export function formatAmount(amount: number): string {
  return formatKrAmount(amount);
}

/** Hele procenter: "12 %". */
export function formatPct(pct: number): string {
  return `${Math.round(Number.isFinite(pct) ? pct : 0)} %`;
}
